/** Shared coaching line styling on Hat setup + turn screens. */
export const HAT_NOTICE_CLASS = "text-typ-ui text-muted-foreground";

/** Clue input styling — matches keyboard-safe setup inputs. */
export const HAT_CLUE_INPUT_CLASS =
  "keyboard-safe-input h-12 w-full rounded-md border border-input bg-background px-3 text-typ-input text-foreground outline-none ring-offset-background focus-visible:ring-2 focus-visible:ring-ring";
